import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  1fr 1fr 1fr 1fr 1fr 1fr ;
        align-items: center;
        justify-content: center;
        min-height: 40px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
  .click{
    color: var(--color-main);
    cursor: pointer;
    text-decoration: underline;
  }
`;

const SatilikAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const [isMoreActive, setIsMoreActive] = useState(null)

  const toggleMore = (item) => {
    if (isMoreActive === item) {
      setIsMoreActive(null);
    } else {
      setIsMoreActive(item);
    }
  };


  return (
    <Container onClick={()=>toggleMore(null)} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data?.vehicleType}</div>
            <div className="col">{data?.model}</div>
            <div className="col">{data?.km}</div>
            <div className="col">{data?.price}</div>
            <div className="col">{data?.description}</div>
            <div className="col click"> <span  onClick={() => {dispatch(setSelectRentalCar(data)); dispatch(showModal("advertShowPhoto"))}}>Fotoğraflar</span> </div>
            <div onClick={(e)=> {toggleMore(data); e.stopPropagation(e) }} className="more"><MdOutlineMoreHoriz/></div>
            {isMoreActive && 
              <div className="detail">
                <p onClick={() => {dispatch(setSelectRentalCar(data)); dispatch(showModal("deleteVehiclesForSale"))}}  className="delete">İlanı Sil</p> 
                { data?.advertStatus === "Arşivde" && <p onClick={() =>{ dispatch(setSelectRentalCar(data)); dispatch(showModal("updateVehiclesForSale"))}}>İlanı Güncelle</p> }
              </div> 
            }
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SatilikAraclarContainer;
